import { Spinner as InnerSpinner, Container } from './spinner';
const Spinner = InnerSpinner;
Spinner.Container = Container;
export default Spinner;
